import { matchEnvByHost } from '@xingternal/malt-tracking';

const trackingEnvironment = matchEnvByHost({
  default: 'xingbox',
  localhost: 'development',
  'preview.xing.com': 'preview',
  'www.xing.com': 'production',
});

export default trackingEnvironment;
